import axios from "axios";
import jwt_decode from "jwt-decode";

const API_URL = "https://rh.industriabasica.net/api/";
//const API_URL = "https://localhost:8000/api/";

class AuthService {
  login(_username, _password) {

  var details = {
      '_username': _username,
      '_password': _password
  };
  
  var formBody = [];
  for (var property in details) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&");

    return axios
      .post(API_URL + "login_check", formBody,  {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}} )
      .then(response => {
        if (response.data.token) {
          var data = jwt_decode(response.data.token);
          //console.log(data.email);
          data.accessToken = response.data.token;
          data.username = data.email;

          //return JSON.parse(data);
          //localStorage.setItem("user", JSON.stringify(response.data.token));
          localStorage.setItem("user", JSON.stringify(data));
        }

        return response.data.token;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(username, email, password) {
    return axios.post(API_URL + "signup", {
      username,
      email,
      password
    });
  }

  getCurrentUser() {
      return JSON.parse(localStorage.getItem('user'));
  }
}

export default new AuthService();
